<template>
  <div>
    <div class="address">
      <i class="iconfont icon-map addLeft"/>
      <div class="addressContent" @click="$router.push('/pages/address/index')">
        <div>
          <p class="msg">
            <span>{{data.address.name}}</span>
            <span>{{data.address.phone}}</span>
          </p>
          <p
            class="addressDetail"
          >{{data.address.province}}{{data.address.city}}{{data.address.region}}{{data.address.detail}}</p>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="express" v-if="data.hasexpress">
        <p class="title">物流信息</p>
        <p>
          物流公司:
          <span>{{data.express.name}}</span>
        </p>
        <p>
          物流单号:
          <span>{{data.express.num}}</span>
        </p>
      </div>
      <div class="bmsgWrap">
        <p class="title">商品列表</p>
        <div class="bmsg">
          <p style="float:left">订单号:{{data.id}}</p>
          <p style="float:right">{{data.create_time}}</p>
        </div>
      </div>
      <div class="orderBody" v-for="(item,index) in data.goods" :key="index">
        <div class="orderItemLeft">
          <img :src="item.img | thumbnail(176,176)">
        </div>
        <div class="orderItemRight">
          <div class="itemMsg">
            <p class="title">{{item.name}}</p>
            <p class="price">￥{{item.pirce}}</p>
            <button v-if="hasfinish&&item.refund" class="sup" @click="Jump(item.oid)">申请售后</button>
            <p v-if="hasfinish&&!item.refund" class="supp">已申请售后</p>
          </div>
          <p class="itemNum">x{{item.num}}</p>
        </div>
      </div>
      <div class="totalWrap">
        <p>
          共{{data.total_num}}件商品，合计:
          <span>￥{{data.total_price}}</span>
        </p>
      </div>
    </div>
    <div class="orderMsg">
      <div class="orderMsgItem">
        <p class="orderMsgtitle">商品总金额:</p>
        <p class="orderMsgvalue colorRed">￥{{data.total_price}}</p>
      </div>
      <div class="orderMsgItem">
        <p class="orderMsgtitle">优惠券:</p>
        <p class="orderMsgvalue colorRed">￥{{data.coupon_price}}</p>
      </div>
      <div class="orderMsgItem">
        <p class="orderMsgtitle">配送费用:</p>
        <p class="orderMsgvalue colorRed">￥{{data.express_price}}</p>
      </div>
      <div class="orderMsgItem">
        <p class="orderMsgtitle">实付金额:</p>
        <p class="orderMsgvalue colorRed">￥{{data.pay_price}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
import Vue from "vue";
Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["data","hasfinish"],
  data() {
    return {};
  },
  activated() {},
  methods: {
    Jump(id){
      this.$router.push({
        path:"/supportsub",
        query:{
          id:id
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../style/skin.less");
.address {
  display: flex;
  background: @white
    url("data:image/png;base64,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")
    bottom left repeat-x;
  background-size: 60px auto;
  padding: 5px 10px;
  .addLeft {
    line-height: 50px;
    font-size: 30px;
    color: @darkP;
  }
  .addressContent {
    flex: 1 1 auto;
    .msg {
      font-size: 14px;
      height: 25px;
      line-height: 25px;
      color: @darkP;
      span:last-child {
        margin-left: 10px;
      }
    }
    .noaddress {
      font-size: 14px;
      height: 50px;
      line-height: 50px;
      color: @darkP;
    }
  }
  .addressDetail {
    font-size: 14px;
    height: 25px;
    line-height: 25px;
    color: @lightP;
  }
  .addRight {
    line-height: 50px;
    font-size: 20px;
    color: @lightP;
  }
}
.body {
  margin-top: 10px;
  .express {
    margin-bottom: 10px;
    padding: 10px 10px;
    background: @white;
    .title {
      padding: 10px 0px;
      border-bottom: 1px solid @veryLightLine;
    }
    p {
      font-size: 14px;
      padding: 5px 0px;
      color: @lightP;
    }
  }
  .bmsgWrap {
    padding: 0px 10px;
    background: @white;
    .title {
      font-size: 14px;
    }
    .bmsg {
      overflow: hidden;
      p {
        font-size: 12px;
        color: @lightP;
      }
    }
  }
  .orderBody {
    padding: 10px 15px 2px 15px;
    background: @white;
    display: flex;
    .orderItemLeft {
      height: 90px;
      width: 90px;
      border: 1px solid #eee;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .orderItemRight {
      display: flex;
      flex: 1 1 auto;
      padding: 0px 10px;
      .itemMsg {
        flex: 1 1 auto;
        position: relative;
        .title {
          max-width: 200px;
          height: 25px;
          line-height: 25px;
          font-weight: 600;
          color: @darkP;
          font-size: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .price {
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: @text;
        }
        .sup{
          position: absolute;
          right: -15px;
          border: 1px solid #ccc;
          color: #555;
          font-size: 14px;
          background: transparent;
          border-radius: 4px;
        }
        .supp{
           position: absolute;
          right: -15px;
          font-size: 14px;
          color: #555;
        }
      }
      .itemNum {
        height: 90px;
        line-height: 70px;
        font-size: 14px;
        color: @lightP;
      }
    }
  }
  .totalWrap {
    padding: 0px 15px;
    text-align: right;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    color: @lightP;
    background: @white;
    span {
      color: @text;
    }
  }
}
.ordermsg {
  margin-top: 10px;
  input {
    border: 0px;
    background: @white;
    width: 100%;
    font-size: 14px;
    padding: 10px 8px;
  }
}
.orderMsg {
  margin-top: 10px;
  padding: 0px 8px;
  background: @white;
  .orderMsgItem {
    border-bottom: 1px solid #eee;
    overflow: hidden;
    padding: 8px 0px;
    .orderMsgtitle {
      font-size: 14px;
      color: @darkP;
      float: left;
    }
    .orderMsgvalue {
      font-size: 14px;
      float: right;
    }
    .colorRed {
      color: @text;
    }
  }
}
.footer {
  position: fixed;
  bottom: 0px;
  height: 50px;
  width: 100%;
  overflow: hidden;
  background: @white;
  p {
    float: left;
    font-size: 14px;
    line-height: 50px;
    margin-left: 20px;
    color: @lightP;
    span {
      color: @text;
    }
  }
  button {
    height: 50px;
    border: 0px;
    background: @btn;
    font-size: 14px;
    color: @white;
    width: 100px;
    float: right;
  }
}
.footerBlock {
  width: 100%;
  height: 50px;
}
</style>